import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import { DropdownItem } from 'reactstrap';
import Icon from '../common/containers/icon';
const MenuDropdownItem = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$glyph = _ref.glyph,
    glyph = _ref$glyph === void 0 ? '' : _ref$glyph,
    title = _ref.title,
    href = _ref.href;
  return /*#__PURE__*/React.createElement(DropdownItem, {
    className: className.length > 0 ? lodash.kebabCase(className) : lodash.kebabCase("mdi-".concat(title)),
    href: href
  }, glyph.length > 0 ? /*#__PURE__*/React.createElement(Icon, {
    glyph: glyph,
    style: {
      marginRight: '10px'
    }
  }) : null, title);
};
MenuDropdownItem.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  glyph: PropTypes.string,
  href: PropTypes.string.isRequired
};
export default MenuDropdownItem;